<template>
    <div id="old-conversations">
        <div class="custom-content">
            <div class="header">
                <div class="closeBtn" @click="toggleChatHistory(false)" />
                <div class="title">
                    <div v-if="oldConversations.length" class="d-flex align-items-center">
                        <md-button
                            :disabled="selectedIndex === 0"
                            style="min-width: 32px; height: 32px; margin: 0"
                            @click="previousPage"
                        >
                            <md-icon>keyboard_arrow_left</md-icon>
                        </md-button>
                        <select id="time-select" v-model="selectedIndex" class="ellipsis">
                            <option v-for="(c, i) in oldConversations" :key="i" :value="i">
                                {{ c.email }}
                                {{ c.createdDate | date("LLL") }}
                            </option>
                        </select>
                        <md-button
                            :disabled="selectedIndex === oldConversations.length - 1 && isEnd"
                            style="min-width: 32px; height: 32px; margin: 0"
                            @click="nextPage"
                        >
                            <md-icon>keyboard_arrow_right</md-icon>
                        </md-button>
                    </div>
                </div>
            </div>
            <div v-if="oldConversations.length" class="body">
                <div v-if="loadingMore" class="spinnerClass">
                    <a-spin></a-spin>
                </div>
                <div v-for="(conversation, i) in oldConversations" v-else :key="i">
                    <MessageList
                        v-if="i === selectedIndex"
                        v-once
                        :always-scroll-to-bottom="true"
                        :colors="colors"
                        :messages="getMessages(conversation)"
                        :participants="getParticipants(conversation)"
                    />
                </div>

                <b-card
                    v-for="(conversation, index) in oldConversations"
                    v-if="false"
                    :key="index"
                    class="mb-1 rounded-0"
                    no-body
                >
                    <template v-if="conversation._id !== activeConversation._id">
                        <b-card-header header-tag="header" role="tab">
                            <b-button block @click="toggleAccordion(index)">
                                {{ conversation.fullname }}
                                <time>&nbsp;&nbsp;{{ conversation.createdDate | date("LLL") }}</time>
                            </b-button>
                        </b-card-header>
                        <b-collapse :id="`accordion-${index}`" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <MessageList
                                    v-once
                                    :always-scroll-to-bottom="true"
                                    :colors="colors"
                                    :messages="messages"
                                    :participants="participants"
                                />
                            </b-card-body>
                        </b-collapse>
                    </template>
                    <template v-if="oldConversations.length < 1">
                        <b-alert class="rounded-0 mb-0 mt-2" show>{{ $t("message.noMessage") }}</b-alert>
                    </template>
                </b-card>

                <div v-if="false">
                    <a-button
                        v-if="!isEnd && oldConversations.length !== 0"
                        :loading="loadingMore"
                        @click="loadOldConversationsMore"
                        >{{ $t("message.loadMore") }}
                    </a-button>
                </div>
            </div>
            <div v-else class="body">
                <a-result title="Konuşma Bulunamadı" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Info from "./svg/Info";
import Representative from "./svg/Representative";
import MessageList from "./popup-chat/MessageList";
import * as _ from "lodash";
import { log2 } from "../utils/log2";
import { toNewMessagesModel } from "../utils/chat";

const log = log2("UserChatHistoryWidget");
export default {
    name: "UserChatHistoryWidget",
    components: {
        Info,
        Representative,
        MessageList,
    },
    data() {
        return {
            currentAccordion: -1,
            oldConversations: [],
            loading: true,
            loadingMore: false,
            isEnd: false,
            page: 1,
            perPage: 5,
            colors: {
                header: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                launcher: {
                    bg: "#4e8cff",
                },
                messageList: {
                    bg: "#ffffff",
                },
                sentMessage: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                receivedMessage: {
                    bg: "#eaeaea",
                    text: "#222222",
                },
                userInput: {
                    bg: "#f4f7f9",
                    text: "#565867",
                },
            },
            selectedIndex: 0,
        };
    },
    beforeDestroy() {
        this.oldConversations = [];
        this.currentAccordion = -1;
    },
    mounted() {
        log("UserChatHistoryWidget mount", this.oldConversations);
        if (this.activeConversation) {
            this.loadOldChats(this.activeConversation.visitor);
        }
    },

    computed: {
        ...mapState({
            activeConversation: (state) => state.chat.activeConversation,
        }),
        ...mapGetters({
            getUser: "user/getUser",
        }),
    },
    methods: {
        ...mapActions({
            loadOldConversations: "chat/loadOldConversations",
            loadOldConversationsAsPaged: "chat/loadOldConversationsAsPaged",
            toggleChatHistory: "chat/toggleChatHistory",
        }),
        toggleAccordion(index) {
            log("toggleAccordion", index);
            this.$root.$emit("bv::toggle::collapse", `accordion-${index}`);
            this.currentAccordion = this.currentAccordion === index ? -1 : index;
        },
        loadOldConversationsMore() {
            this.loadingMore = true;
            this.page++;
            this.loadOldConversationsAsPaged({
                conversationId: this.activeConversation._id,
                visitor: this.activeConversation.visitor,
                page: this.page,
                perPage: this.perPage,
            }).then((response) => {
                this.oldConversations.push(...response.data.history);
                this.loadingMore = false;
                this.selectedIndex = this.selectedIndex + 1;

                if (response.data.count === 0 || this.oldConversations.length >= response.data.total) this.isEnd = true;
            });
        },
        getParticipants(conversation) {
            /**
             * messageType: "user"
             message: "zxczxc"
             userId: "5d14ee322d95ad001ebdf214"
             username: "enes"
             uniqMessageId: ""
             conversationId: "5e755e8470adb40019d960b7"
             date: "2020-03-21T00:37:28.040Z"
             *
             */
            const supportUsers = conversation.messages
                .filter((x) => x.messageType === "user")
                .map((x) => ({
                    id: x.userId,
                    name: x.username,
                }));

            return _.uniqBy(supportUsers, (q) => q.name);
        },
        getMessages(conversation) {
            return toNewMessagesModel(conversation.messages, this);
        },
        loadOldChats(visitor) {
            this.loading = true;
            let conversationId = this.activeConversation._id;
            this.loadOldConversationsAsPaged({
                visitor,
                conversationId,
                page: this.page,
                perPage: this.perPage,
            }).then((response) => {
                this.loading = false;
                log("response data", response.data);
                if (response.data.count > 0) {
                    this.oldConversations.push(...response.data.history);
                }
                if (response.data.total === response.data.count) {
                    this.isEnd = true;
                }
            });
        },
        previousPage() {
            if (this.selectedIndex > 0) this.selectedIndex = this.selectedIndex - 1;
        },
        nextPage() {
            if (this.selectedIndex < this.oldConversations.length - 1) this.selectedIndex = this.selectedIndex + 1;
            else this.loadOldConversationsMore();
        },
    },
    watch: {
        activeConversation: {
            handler(newValue, oldValue) {
                log("activeConversation update", newValue, oldValue);

                if (newValue && oldValue && newValue._id !== oldValue._id) {
                    this.loadOldChats(newValue.visitor);
                } else {
                    this.loading = false;
                }
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.new-theme {
    .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 200px;
    }

    #old-conversations {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 99999999999;
        padding: 30px;
        background-color: #0c131bcc;

        .custom-content {
            background-color: #f5f5f5;
            border-radius: 8px;
            width: 100%;
            height: 100%;
            overflow: hidden;
            box-shadow: 0 0 10px #000000;

            .header {
                height: 36px;
                box-shadow: 0 0 2px #00000080 inset;
                padding: 0 15px;
                display: flex;
                align-items: center;

                .closeBtn {
                    height: 12px;
                    width: 12px;
                    border-radius: 50%;
                    background-color: #ff4d4f;
                    box-shadow: 0 0 3px #00000080 inset;
                    transition: all 0.3s;
                    cursor: pointer;

                    &:hover {
                        box-shadow: 0 0 6px #00000080 inset;
                    }
                }

                .title {
                    font-family: Poppins;
                    font-size: 16px;
                    font-weight: 400;
                    color: #1e1e2d;
                    justify-self: center;
                    margin: auto;
                    padding-right: 12px;
                }
            }

            .body {
                padding: 10px 15px;
                background-color: #fefefe;
                height: 100%;
                overflow-y: scroll;

                .spinnerClass {
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
        }
    }
}
</style>
